import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { JwtService } from '../auth/jwt.service';

@Injectable()
export class DefaultHeadersInterceptor implements HttpInterceptor {
  constructor(private jwtService: JwtService) {}

  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    const isFormData = req.body instanceof FormData;

    // Não sobrescrever Content-Type se já foi definido explicitamente no request.
    // Não definir em multipart/form-data: o browser precisa gerar o boundary
    // automaticamente no header (ex: multipart/form-data; boundary=----...).
    // Forçar 'application/json' aqui quebraria o parse no servidor.
    let headers =
      isFormData || req.headers.has('Content-Type')
        ? req.headers
        : req.headers.set('Content-Type', 'application/json');

    headers = headers.set('Accept', 'application/json');

    const token = this.jwtService.accessToken;
    if (token && this.isInternalRequest(req.url)) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return next.handle(req.clone({ headers }));
  }

  private isInternalRequest(url: string): boolean {
    return (
      !url.startsWith('http') ||
      url.startsWith(environment.pathApi) ||
      url.startsWith(environment.ceppemAiApi)
    );
  }
}
